import React from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcher = ({ className = '' }) => {
    const { i18n } = useTranslation();
    const current = i18n.language?.startsWith('ja') ? 'ja' : 'en';

    const setLang = (lng) => {
        if (lng !== current) i18n.changeLanguage(lng);
    };

    return (
        <div className={`flex items-center rounded-lg border border-gray-200 overflow-hidden text-xs font-semibold ${className}`}>
            <button
                type="button"
                onClick={() => setLang('en')}
                className={`px-2.5 py-1 transition-colors ${current === 'en' ? 'bg-primary-50 text-primary-600' : 'text-gray-500 hover:bg-gray-50'}`}
            >
                EN
            </button>
            <button
                type="button"
                onClick={() => setLang('ja')}
                className={`px-2.5 py-1 transition-colors border-l border-gray-200 ${current === 'ja' ? 'bg-primary-50 text-primary-600' : 'text-gray-500 hover:bg-gray-50'}`}
            >
                日本語
            </button>
        </div>
    );
};
